"use client";

import { BSRArrowLeft } from "./bsr/BSRArrowLeft";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { ArrowLeft as LegacyArrowLeft } from "./legacy/ArrowLeft";

export const ArrowLeft = createBSRExperimentIcon(LegacyArrowLeft, BSRArrowLeft);
